import { useTranslation } from "react-i18next";
import "./landing-pv-section5.scss";

export const usePvSection5 = () => {
  const { t } = useTranslation();

  return { t };
};
